import script from "./UserRegisterPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserRegisterPage.vue?vue&type=script&lang=ts&setup=true"

import "./UserRegisterPage.vue?vue&type=style&index=0&id=e6cfe4b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6cfe4b4"]])

export default __exports__